import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Button,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography
} from '@mui/material';

import { STRINGS } from 'src/commons';
import ImagePicker from 'src/components/imagePicker';
import AddTrainerModal from '../Modals/addTrainerModal';
import AddMembershipPlanModal from '../Modals/addMembershipPlanModal';
import AddBatchModal from '../Modals/addBatchesModal';
import PhoneInput from 'react-phone-input-2';
import AddDietPlanModal from '../Modals/addDietPlanModal'
const MemberForm = ({
  errors,
  handleBlur,
  handleChange,
  handleSubmit,
  setFieldValue,
  isSubmitting,
  touched,
  values,
  isFromUpdateMember = false,
  heading = '',
  number,
  countryCode,
  HandleChange,
  showerror
}) => {
  const [openTrainerModal, setOpenTrainerModal] = useState(false);
  const [openMembershipModal, setOpenMembershipModal] = useState(false);
  const [openDietPlanModal, setOpenDietPlanModal] = useState(false);
  const [openBatchModal, setOpenBatchModal] = useState(false);
  const handleClosetrainerModal = () => setOpenTrainerModal(false);
  const handleOpentrainerModal = () => setOpenTrainerModal(true);
  const handleCloseMembershipModal = () => setOpenMembershipModal(false);
  const handleOpenDietplanModal = () => setOpenDietPlanModal(true);
  const handleCloseDietplanModal = () => setOpenDietPlanModal(false);
  const handleOpenMembershipModal = () => setOpenMembershipModal(true);
  const handleCloseBatchModal = () => setOpenBatchModal(false);
  const handleOpenBatchModal = () => setOpenBatchModal(true);
  const [imageFile, setImageFile] = useState(null);
  const { trainerList } = useSelector((state) => state.trainer);
  const { membershipPlanList } = useSelector((state) => state.membershipPlan);
  const { dietPlanList } = useSelector((state) => state.dietPlan);
  const { batchList } = useSelector((state) => state.batches);

  const Days = [
    '1st',
    '2nd',
    '3rd',
    '4th',
    '5th',
    '6th',
    '7th',
    '8th',
    '9th',
    '10th',
    '11th',
    '12th',
    '13th',
    '14th',
    '15th',
    '16th',
    '17th',
    '18th',
    '19th',
    '20th',
    '21th',
    '22th',
    '23th',
    '24th',
    '25th',
    '26th',
    '27th',
    '28th'
  ];
  
  return (
    <>
      <>
        <Modal
          sx={{ overflow: 'scroll', padding: '1rem' }}
          open={openTrainerModal}
          onClose={handleClosetrainerModal}
        >
          <AddTrainerModal handleCloseModal={handleClosetrainerModal} />
        </Modal>

        <Modal
          sx={{ overflow: 'scroll', padding: '1rem' }}
          open={openMembershipModal}
          onClose={handleCloseMembershipModal}
        >
          <AddMembershipPlanModal
            handleCloseModal={handleCloseMembershipModal}
          />
        </Modal>

        <Modal
          sx={{ overflow: 'scroll', padding: '1rem' }}
          open={openDietPlanModal}
          onClose={handleCloseDietplanModal}
        >
          <AddDietPlanModal
            handleCloseModal={handleCloseDietplanModal}
          />
        </Modal>

        <Modal
          sx={{ overflow: 'scroll', padding: '1rem' }}
          open={openBatchModal}
          onClose={handleCloseBatchModal}
        >
          <AddBatchModal handleCloseModal={handleCloseBatchModal} />
        </Modal>
      </>

      <form onSubmit={handleSubmit}>
        <Box sx={{ mb: 3 }}>
          <Typography color="textPrimary" variant="h2">
            {heading}
          </Typography>
        </Box>
        {false && (
          <TextField
            fullWidth
            label="Member Id"
            margin="normal"
            name="memberId"
            disabled
            type="text"
            value={values?.memberId}
            variant="outlined"
          />
        )}
        <TextField
          error={Boolean(touched.name && errors.name)}
          fullWidth
          helperText={touched.name && errors.name}
          label="Name"
          margin="normal"
          name="name"
          onBlur={handleBlur}
          onChange={handleChange}
          type="text"
          value={values.name || ''}
          variant="outlined"
        />
        <TextField
          error={Boolean(touched.fatherName && errors.fatherName)}
          fullWidth
          helperText={touched.fatherName && errors.fatherName}
          label="Father name"
          margin="normal"
          name="fatherName"
          onBlur={handleBlur}
          onChange={handleChange}
          type="text"
          value={values.fatherName}
          variant="outlined"
        />
        <TextField
          error={Boolean(touched.email && errors.email)}
          fullWidth
          helperText={touched.email && errors.email}
          label="Email Address"
          margin="normal"
          name="email"
          onBlur={handleBlur}
          onChange={handleChange}
          type="email"
          value={values.email}
          variant="outlined"
        />
        <TextField
          error={Boolean(touched.address && errors.address)}
          fullWidth
          helperText={touched.address && errors.address}
          label="Address"
          margin="normal"
          name="address"
          onBlur={handleBlur}
          onChange={handleChange}
          type="text"
          value={values.address}
          variant="outlined"
        />

        <div className="phone">
          <label for="phone" className="label">
            Mobile Number
          </label>
          <PhoneInput
            country={'us'}
            inputClass="input"
            value={number}
            inputStyle={{
              height: '3.5rem',
              width: '100%',
              border:
                touched.mobileNumber && errors?.mobileNumber
                  ? '1px solid red'
                  : '1px solid rgba(0, 0, 0, 0.23)',
              marginTop: '16px'
            }}
            name="mobileNumber"
            onChange={(val, obj) => {
              HandleChange(val, obj.dialCode);
              setFieldValue('mobileNumber', val);
             setFieldValue('callingCode', `+${obj?.dialCode}`);
            }}
            inputProps={{
              required: true
            }}
            searchPlaceholder="Search"
            enableSearch
            countryCodeEditable={false}
          />
          {touched.mobileNumber && errors?.mobileNumber && (
            <p
              style={{
                color: 'red',
                fontFamily: 'Roboto',
                fontSize: '0.8rem',
                marginLeft: '15px',
                marginTop: '5px'
              }}
            >
              {errors?.mobileNumber}
            </p>
          )}
        </div>

        {/* <TextField
          error={Boolean(touched.mobileNumber && errors.mobileNumber)}
          fullWidth
          helperText={touched.mobileNumber && errors.mobileNumber}
          label="Mobile Number"
          margin="normal"
          name="mobileNumber"
          onBlur={handleBlur}
          onChange={handleChange}
          type="text"
          value={values.mobileNumber}
          variant="outlined"
        /> */}

        <TextField
          error={Boolean(touched.dateOfBirth && errors.dateOfBirth)}
          fullWidth
          helperText={touched.dateOfBirth && errors.dateOfBirth}
          InputLabelProps={{
            shrink: true
          }}
          label="Date of birth"
          margin="normal"
          name="dateOfBirth"
          onBlur={handleBlur}
          onChange={handleChange}
          type="date"
          value={values.dateOfBirth}
          variant="outlined"
        />

        <FormControl
          variant="outlined"
          fullWidth
          margin="normal"
          id="gender-select"
        >
          <InputLabel id="gender-label">{STRINGS.GENDER}</InputLabel>
          <Select
            labelId="gender-label"
            id="gender"
            value={values.gender}
            onChange={handleChange}
            label="Gender"
            name="gender"
          >
            <MenuItem name="gender" value={0}>
              {STRINGS.MALE}
            </MenuItem>
            <MenuItem name="gender" value={1}>
              {STRINGS.FEMALE}
            </MenuItem>
          </Select>
        </FormControl>

        <TextField
          error={Boolean(touched.weight && errors.weight)}
          fullWidth
          helperText={touched.weight && errors.weight}
          label="Weight(kg)"
          margin="normal"
          name="weight"
          onBlur={handleBlur}
          onChange={handleChange}
          type="number"
          value={values.weight}
          variant="outlined"
        />

        <TextField
          error={Boolean(touched.height && errors.height)}
          fullWidth
          helperText={touched.height && errors.height}
          label="Height(cm)"
          margin="normal"
          name="height"
          onBlur={handleBlur}
          onChange={handleChange}
          type="number"
          value={values.height}
          variant="outlined"
        />

        {membershipPlanList.length <= 0 ? (
          <TextField
            error={Boolean(touched.membershipPlan && errors.membershipPlan)}
            onChange={handleChange}
            fullWidth
            helperText={touched.membershipPlan && errors.membershipPlan}
            InputLabelProps={{
              shrink: true
            }}
            label="Select MembershipPlan"
            margin="normal"
            type="text"
            variant="outlined"
            disabled
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="start"
                  sx={{ cursor: 'pointer' }}
                  onClick={() => {
                    handleOpenMembershipModal();
                    // navigate(CONSTANTS.ROUTES.PRIVATE_ROUTES.ADD_TRAINER);
                  }}
                >
                  {
                    <Button sx={{}} color="success" variant="outlined">
                      Add MembershipPlan
                    </Button>
                  }
                </InputAdornment>
              )
            }}
          />
        ) : (
          <FormControl
            variant="outlined"
            fullWidth
            margin="normal"
            id="membershipPlan-select"
          >
            <InputLabel id="membershipPlan-label">
              {'Select MembershipPlan'}
            </InputLabel>
            <Select
              error={Boolean(touched.membershipPlan && errors.membershipPlan)}
              value={values.membershipPlan}
              onChange={handleChange}
              labelId="membershipPlan-label"
              id="membershipPlan"
              label="Select membershipPlan"
              name="membershipPlan"
            >
              {membershipPlanList?.map((membershipPlan, index) => (
                <MenuItem
                  key={index}
                  name="membershipPlan"
                  value={membershipPlan?.name}
                >
                  {membershipPlan?.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {dietPlanList.length <= 0 ? (
          <TextField
            error={Boolean(touched.dietplan && errors.dietplan)}
            onChange={handleChange}
            fullWidth
            helperText={touched.dietplan && errors.dietplan}
            InputLabelProps={{
              shrink: true
            }}
            label="Select Dietplan"
            margin="normal"
            type="text"
            variant="outlined"
            disabled
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="start"
                  sx={{ cursor: 'pointer' }}
                  onClick={() => {
                    handleOpenDietplanModal();
                    // navigate(CONSTANTS.ROUTES.PRIVATE_ROUTES.ADD_TRAINER);
                  }}
                >
                  {
                    <Button sx={{}} color="success" variant="outlined">
                      Add Dietplan
                    </Button>
                  }
                </InputAdornment>
              )
            }}
          />
        ) : (
          <FormControl
            variant="outlined"
            fullWidth
            margin="normal"
            id="dietplan-select"
          >
            <InputLabel id="dietplan-label">
              {'Select dietplan'}
            </InputLabel>
            <Select
              error={Boolean(touched.dietplan && errors.dietplan)}
              value={values.dietplan}
              onChange={handleChange}
              labelId="dietplan-label"
              id="dietplan"
              label="Select dietplan"
              name="dietplan"
            >
              {dietPlanList?.map((dietplan, index) => (
                <MenuItem
                  key={index}
                  name="dietplan"
                  value={dietplan?.name}
                >
                  {dietplan?.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {batchList.length <= 0 ? (
          <TextField
            error={Boolean(touched.batch && errors.batch)}
            onChange={handleChange}
            fullWidth
            helperText={touched.batch && errors.batch}
            InputLabelProps={{
              shrink: true
            }}
            label="Select Batch"
            margin="normal"
            type="text"
            variant="outlined"
            disabled
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="start"
                  sx={{ cursor: 'pointer' }}
                  onClick={() => {
                    handleOpenBatchModal();
                    // navigate(CONSTANTS.ROUTES.PRIVATE_ROUTES.ADD_TRAINER);
                  }}
                >
                  {
                    <Button sx={{}} color="success" variant="outlined">
                      Add Batch
                    </Button>
                  }
                </InputAdornment>
              )
            }}
          />
        ) : (
          <FormControl
            variant="outlined"
            fullWidth
            margin="normal"
            id="batch-select"
          >
            <InputLabel id="batch-label">{'Select Batch'}</InputLabel>
            <Select
              error={Boolean(touched.batch && errors.batch)}
              value={values.batch}
              onChange={handleChange}
              labelId="batch-label"
              id="batch"
              label="Select batch"
              name="batch"
            >
              {batchList.map((batch, index) => (
                <MenuItem key={index} name="batch" value={batch?.name}>
                  {batch?.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {trainerList.length <= 0 ? (
          <TextField
            error={Boolean(touched.trainer && errors.trainer)}
            onChange={handleChange}
            fullWidth
            helperText={touched.trainer && errors.trainer}
            InputLabelProps={{
              shrink: true
            }}
            label="Select Trainer"
            margin="normal"
            type="text"
            variant="outlined"
            disabled
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="start"
                  sx={{ cursor: 'pointer' }}
                  onClick={() => {
                    handleOpentrainerModal();
                    // navigate(CONSTANTS.ROUTES.PRIVATE_ROUTES.ADD_TRAINER);
                  }}
                >
                  {
                    <Button sx={{}} color="success" variant="outlined">
                      Add trainer
                    </Button>
                  }
                </InputAdornment>
              )
            }}
          />
        ) : (
          <FormControl
            variant="outlined"
            fullWidth
            margin="normal"
            id="trainer-select"
          >
            <InputLabel id="trainer-label">{'Select trainer'}</InputLabel>
            <Select
              error={Boolean(touched.trainer && errors.trainer)}
              value={values.trainer}
              labelId="trainer-label"
              id="trainer"
              onChange={handleChange}
              label="Select trainer"
              name="trainer"
            >
              {trainerList.map((trainer, index) => (
                <MenuItem
                  key={index}
                  name="membershipPlan"
                  value={trainer?.name}
                >
                  {trainer?.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        <TextField
          error={Boolean(
            touched.membershipStartDate && errors.membershipStartDate
          )}
          helperText={touched.membershipStartDate && errors.membershipStartDate}
          fullWidth
          InputLabelProps={{
            shrink: true
          }}
          label="Membership Start Date"
          margin="normal"
          name="membershipStartDate"
          onBlur={handleBlur}
          onChange={handleChange}
          type="date"
          value={values?.membershipStartDate}
          variant="outlined"
        />

        <TextField
          error={Boolean(touched.membershipEndDate && errors.membershipEndDate)}
          helperText={touched.membershipEndDate && errors.membershipEndDate}
          fullWidth
          InputLabelProps={{
            shrink: true
          }}
          label="Membership End Date"
          margin="normal"
          name="membershipEndDate"
          onBlur={handleBlur}
          onChange={handleChange}
          type="date"
          value={values?.membershipEndDate}
          variant="outlined"
        />

        <FormControl
          variant="outlined"
          fullWidth
          margin="normal"
          id="paymentReminderDay-select"
        >
          <InputLabel id="paymentReminderDay-label">
            {'Select Payment Remainder Day'}
          </InputLabel>
          <Select
            error={Boolean(
              touched.paymentReminderDay && errors.paymentReminderDay
            )}
            value={values.paymentReminderDay}
            labelId="paymentReminderDay-label"
            id="paymentReminderDay"
            onChange={handleChange}
            label="Select Payment Remainder Day"
            name="paymentReminderDay"
          >
            {Days.map((day, index) => (
              <MenuItem key={index} name="paymentReminderDay" value={index + 1}>
                {day}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          error={Boolean(touched.remarks && errors.remarks)}
          fullWidth
          helperText={touched.remarks && errors.remarks}
          label="Remarks"
          InputLabelProps={{
            shrink: true
          }}
          margin="normal"
          name="remarks"
          onBlur={handleBlur}
          onChange={handleChange}
          type="text"
          value={values.remarks}
          variant="outlined"
        />

        <TextField
          error={Boolean(touched.profilePic && errors.profilePic)}
          fullWidth
          helperText={touched.profilePic && errors.profilePic}
          label="Profile Pic"
          InputLabelProps={{
            shrink: true
          }}
          margin="normal"
          id="profilePic"
          name="profilePic"
          onBlur={handleBlur}
          inputProps={{
            accept: 'image/*'
          }}
          onChange={(event) => {
            setFieldValue('profilePic', event?.currentTarget?.files[0]);
            const file = event?.currentTarget?.files[0];
            if (!file) {
              setImageFile(null);
              return;
            }
            const fileImage = new FileReader();
            fileImage.readAsDataURL(file);
            fileImage.onload = () => {
              setImageFile(fileImage.result);
            };
          }}
          type="file"
          variant="outlined"
        />

        <ImagePicker pickedImage={imageFile} setImage={setImageFile} />

        <Box sx={{ py: 2 }}>
          <Button
            sx={{
              textTransform: 'none'
            }}
            color="primary"
            disabled={isSubmitting}
            onClick={() => {
              showerror();
            }}
            fullWidth
            size="large"
            type="submit"
            variant="contained"
          >
            {heading}
          </Button>
        </Box>
      </form>
    </>
  );
};

export default MemberForm;
